import React from 'react';
import Swal from 'sweetalert2';
import { getWithAuth } from '../../api/api';
import { API_URLS } from '../../api/apiConfig';

class ModalCancelBooking extends React.Component {
    static handleChangeStatus = async (id) => {
        const changeStatusApi = async (id) => {
            try {
                await getWithAuth(API_URLS.CANCEL_BOOKING_TO_RR(id));
            } catch (error) {
                console.error('Error changing status:', error);
                throw error;
            }
        };

        const result = await Swal.fire({
            title: '¡Cuidado!',
            text: 'Eliminar un enlace puede afectar al comportamiento general del algoritmo',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Eliminar enlace',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-sm btn-primary',
                cancelButton: 'btn btn-sm btn-secondary',
            },
        });

        if (result.isConfirmed) {
            try {
                Swal.fire({
                    title: 'Eliminando...',
                    text: 'Por favor, espera mientras eliminamos el enlace',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        Swal.showLoading(); // Mostrar spinner mientras la promesa se ejecuta
                    },
                });

                await changeStatusApi(id);

                await Swal.fire({
                    icon: 'success',
                    title: 'Enlace eliminado',
                    text: 'El enlace se ha eliminado correctamente.',
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                });

                // Recargar la página
                //window.location.reload();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar el enlace',
                    text: 'Hubo un problema al intentar eliminar el enlace. Por favor, inténtalo de nuevo más tarde.',
                });
            }
        }
    };

    render() {
        return null;
    }
}

export default ModalCancelBooking;
